import { isNone } from 'iotera-base/object'
import { getToken as getTenantToken, setToken as setTenantToken, removeToken as removeTenantToken } from './tenant'
import { getToken as getAppToken, setToken as setAppToken, removeToken as removeAppToken } from './app'

export function tenantToken() {
    const token = getTenantToken();

    if (isNone(token)) {
        return null;
    }

    return {
        ...token
    }
}

export function appToken(domain, isTenant) {

    let token;
    if (isTenant) {
        token = getTenantToken();
    } else {
        token = getAppToken(domain);
    }

    if (isNone(token)) {
        return null;
    }

    return {
        ...token,
        isTenant,
        domain
    }
}

export function setToken(domain, isTenant, id, token) {

    if (isTenant) {
        setTenantToken(id, token);
    } else {
        setAppToken(domain, id, token);
    }
}

export function setTokenDit(dit, id, token) {

    if (dit.isTenant) {
        setTenantToken(id, token);
    } else {
        setAppToken(dit.domain, id, token);
    }
}

export function removeToken(domain, isTenant) {

    if (isTenant) {
        removeTenantToken();
    } else {
        removeAppToken(domain);
    }
}

export function removeTokenDit(dit) {

    if (dit.isTenant) {
        removeTenantToken();
    } else {
        removeAppToken(dit.domain);
    }
}